<template>
  <div class="deals-filters">
    <div class="filters-block">
      <h5>Sectors</h5>
      <el-form-item>
        <el-select
          v-model="filters.sector"
          multiple
          filterable
          default-first-option
          placeholder="Select sector"
          @change="updateFiltersMulti"
        >
          <el-option
            v-for="item in optionsData.asokoSectorOptions"
            :label="item.name"
            :value="item.name"
            :key="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
    </div>

    <div class="controls">
      <button @click="saveFilters" class="btn btn-primary">
        Save as Default
      </button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import optionsData from "@/data/options";

export default {
  name: "deals-filters",
  computed: {
    optionsData() {
      return optionsData;
    },
    interest() {
      return this.$store.getters["account/interest"];
    },
    appliedFilters() {
      return this.$store.getters["deals/filters"];
    },
  },
  data() {
    return {
      filters: {
        sector: [],
      },
    };
  },
  mounted() {
    this.applyExistingFilters();
  },
  methods: {
    applyExistingFilters() {
      this.filters = { ...this.appliedFilters };
    },
    updateFilters(v) {
      const value = v?.target?.value;
      if (!value) {
        return;
      }
      const name = v.target.name;
      const isChecked = v.target.checked;
      if (value === "all") {
        if (isChecked) {
          this.filters[name] = this.optionsData[name]
            .map((i) => i.value || i.name || i.label)
            .concat("all");
        } else {
          this.filters[name] = [];
        }
      }
      if (value !== "all") {
        if (isChecked) {
          if (
            this.optionsData[name].length === this.filters[name].length &&
            typeof this.filters[name] !== "string"
          ) {
            this.filters[name].push("all");
          }
        } else {
          this.filters[name] = this.filters[name].filter((i) => i !== "all");
        }
      }
      this.$store.dispatch("deals/updateFilters", this.filters);
    },
    updateFiltersMulti() {
      this.$store.dispatch("deals/updateFilters", this.filters);
    },
    saveFilters() {
      const interest = Object.assign(this.interest, {
        ..._.pick(this.filters, ["sector"]),
      });

      if (!interest.dealStructure) delete interest.dealStructure;
      this.$store.dispatch("account/update", interest).then(() => {
        return this.$store.dispatch("messages/showSuccessMessage", {
          text: "Your deal filter preferences have been saved",
          confirmButtonText: "Ok",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.deals-filters {
  padding-left: 10px;
  display: flex;
  flex-wrap: wrap;
}
.filters-block {
  display: inline-block;
  flex-basis: 200px;
  margin-right: 30px;
  padding-bottom: 15px;
  h5 {
    color: #0e3167;
    font-size: 14px;
  }
  label {
    margin-left: 5px;
    color: #7e8299;
    font-size: 14px;
  }
}
.controls {
  margin-top: 20px;
  flex: 1 1 100%;
  border-top: 1px solid #eee;
  padding-top: 20px;
  .btn-primary {
    cursor: pointer;
    &:hover {
      transition: all 0.2s;
      color: white;
      background: lighten(#0e3167, 10%) !important;
    }
  }
}
</style>
